import { Card, ProgressCircle } from "@/components";
import { getValidClassNames } from "@/utils";
import { Button, ButtonProps } from "@netfront/ui-library";

export interface LessonCardProps {
  button?: ButtonProps;
  secondaryButton?: ButtonProps;
  description?: string;
  footerContent?: React.ReactNode;
  image?: {
    alt: string;
    src: string;
    additionalClassNames?: string;
  };
  percentageCompleted?: number;
  title: string;
}

export const LessonCard = ({ button, secondaryButton, description, footerContent, image, percentageCompleted, title }: LessonCardProps) => {
  return(
    <Card additionalClassNames="flex flex-col lg:flex-row gap-8 color-black shadow-none">
      {image && (
        <img
          alt={image.alt}
          className={getValidClassNames({
            "w-full max-w-48 rounded-lg self-start": true,
            [String(image.additionalClassNames)]: Boolean(image.additionalClassNames)
          })}
          src={image.src}
        />
      )}

      <div className="flex flex-col flex-1 gap-4">
        <div className="flex items-center flex-1">
          <h3 className="h4 flex-1 mr-4">
            {title}
          </h3>
          {percentageCompleted !== undefined && (
            <ProgressCircle
              additionalClassNames="ml-auto"
              percentageCompleted={percentageCompleted}
            />
          )}

        </div>

        <div className="flex-1">
          {description && (
            <div
              dangerouslySetInnerHTML={{
                __html: description
              }}
            />
          )}
        </div>

        <hr/>
        <div className="flex flex-col lg:flex-row lg:items-end gap-3">
          <div className="flex-1">
            {footerContent}
          </div>

          {(secondaryButton || button) && (
            <div className="flex flex-col gap-2">
              {secondaryButton && <Button {...secondaryButton} />}
              {button && <Button {...button} />}
            </div>
          )}
        </div>
      </div>
    </Card>
  )
};